(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promotional-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class PromotionalProductCarousel {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-promo-viewport]');
      this.track = section.querySelector('[data-promo-track]');
      this.slides = Array.from(section.querySelectorAll('[data-promo-slide]'));
      this.index = 0;
      this.state = null;
      this.timer = null;
      this.animationFrame = null;
      this.storageKey = `promo-carousel-state:${window.location.pathname}:${section.dataset.sectionId}`;
      this.signature = this.slides.map((slide) => `${slide.dataset.promoSlideId}:${slide.dataset.duration}`).join('|');
      this.bindEvents();
      this.resume();
    }

    bindEvents() {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.resume();
      });
      window.addEventListener('storage', (event) => {
        if (event.key === this.storageKey) this.resume();
      });
    }

    activate(newIndex) {
      this.slides.forEach((slide, index) => {
        const active = index === newIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.index = newIndex;
    }

    createState() {
      return { signature: this.signature, index: 0, startedAt: Date.now(), updatedAt: Date.now() };
    }

    readState() {
      try {
        const state = JSON.parse(window.localStorage.getItem(this.storageKey));
        if (
          state
          && state.signature === this.signature
          && Number.isInteger(state.index)
          && state.index >= 0
          && state.index < this.slides.length
          && Number.isFinite(Number(state.startedAt))
        ) return state;
      } catch (error) {}
      return this.createState();
    }

    writeState(state) {
      state.updatedAt = Date.now();
      try { window.localStorage.setItem(this.storageKey, JSON.stringify(state)); } catch (error) {}
    }

    getDuration(index) {
      return Number(this.slides[index].dataset.duration) || 120000;
    }

    syncState() {
      const state = this.readState();
      const now = Date.now();
      let changed = false;
      while (this.slides.length > 1 && now - Number(state.startedAt) >= this.getDuration(state.index)) {
        state.startedAt = Number(state.startedAt) + this.getDuration(state.index);
        state.index = (state.index + 1) % this.slides.length;
        changed = true;
      }
      this.state = state;
      this.index = state.index;
      if (changed) this.writeState(state);
      return state;
    }

    resume() {
      this.stop();
      const state = this.syncState();
      this.activate(state.index);
      if (!document.hidden && this.slides.length > 1) this.schedule(state);
    }

    schedule(state) {
      this.stop();
      const elapsed = Math.max(0, Date.now() - Number(state.startedAt));
      const remaining = Math.max(0, this.getDuration(state.index) - elapsed);
      this.timer = window.setTimeout(() => this.advance(), remaining);
      this.updateProgress(state);
    }

    advance() {
      const state = this.state || this.readState();
      state.index = (state.index + 1) % this.slides.length;
      state.startedAt = Date.now();
      this.state = state;
      this.writeState(state);
      this.activate(state.index);
      this.schedule(state);
    }

    updateProgress(state) {
      const slide = this.slides[this.index];
      const progress = slide.querySelector('[data-promo-progress]');
      const progressBar = slide.querySelector('[data-promo-progress-bar]');
      const countdown = slide.querySelector('[data-promo-countdown]');
      if (!progress || !progressBar || !countdown) return;
      const draw = () => {
        const duration = this.getDuration(this.index);
        const elapsed = Math.min(Date.now() - Number(state.startedAt), duration);
        const percentage = Math.min(100, Math.max(0, (elapsed / duration) * 100));
        const remaining = Math.max(0, duration - elapsed);
        const remainingPercentage = remaining / duration;
        const totalSeconds = Math.ceil(remaining / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = (totalSeconds % 60).toString().padStart(2, '0');
        progressBar.style.width = `${remainingPercentage * 100}%`;
        const progress_1 = remaining / duration;

        let hue;
        if (progress_1 > 0.6) {
          hue = 60 + ((progress_1 - 0.6) / 0.4) * 60;
        }
        else {
          hue = (progress_1 / 0.6) * 60;
        }
        progressBar.style.backgroundColor = `hsl(${hue}, 90%, 48%)`;
        progress.setAttribute('aria-valuenow', Math.round(percentage));
        countdown.innerHTML = `${minutes}<span>m</span> ${seconds}<span>s</span>`;
        if (remaining > 0 && !document.hidden) this.animationFrame = window.requestAnimationFrame(draw);
      };
      draw();
    }

    stop() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
      if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  }

  document.querySelectorAll('[data-promo-carousel]').forEach((section) => {
    if (!section.dataset.promoCarouselInitialized) {
      section.dataset.promoCarouselInitialized = 'true';
      new PromotionalProductCarousel(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
